module.exports = __webpack_public_path__ + "img/tomedecisoes.24d131bf.svg";